/** Job work units and helpers (dyeing per lot, per colour, per saree…). */
export const UNIT_LABEL: Record<string, string> = {
  JOB: "Per job / lot",
  COLOUR: "Per colour",
  SAREE: "Per saree",
  KG: "Per kg",
  PIECE: "Per piece",
};

export const UNIT_SHORT: Record<string, string> = {
  JOB: "job",
  COLOUR: "colour",
  SAREE: "saree",
  KG: "kg",
  PIECE: "piece",
};

/** "18214, 18215 18216" → ["18214", "18215", "18216"]; anything that isn't digits is left for the server to refuse. */
export const parseSarees = (raw: string): string[] =>
  Array.from(new Set(raw.split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean)));

/** What the entry will pay, shown before saving (the server works out the real amount). */
export const previewAmount = (quantity: string, rate: string): number | null => {
  const q = Number(quantity);
  const r = Number(rate);
  if (!quantity.trim() || !rate.trim() || !Number.isFinite(q) || !Number.isFinite(r) || q <= 0 || r <= 0) return null;
  return Math.round(q * r * 100) / 100;
};
